<template>
    <div>
        <div class="qrCode" v-if="qrCode.filePath">
            <p>微信扫一扫</p>
            <p>手机看托盘</p>
            <img :src="qrCode.filePath" alt="网格九脚注塑托盘">
        </div>
    </div>
</template>

<script>
export default {
    props:['qrCode']
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
    .qrCode {
        display: none;
    }
}
.qrCode {
    width: 110px;
    height: 160px;
    background: #ff9000;
    border-radius: 3px;
    position: fixed;
    right: 70px;
    bottom: 50px;
    text-align: center;
    color: #fff;
    p:first-child {
        margin-top: 10px;
    }
    img {
        margin-top: 3px;
        width: 100px;
        height:100px;
    }
}
</style>